/*
 * Premium PDP — multi-layer parallax on the left-column hero.
 * Each [data-parallax] element inside .premium_media_static drifts vertically as
 * the column travels through the viewport. Different data-parallax-shift values
 * per layer (background vs. foreground book) create the depth between them.
 * Cross-browser (scroll listener + requestAnimationFrame). Disabled under
 * prefers-reduced-motion: layers are left untouched.
 *
 * Per-layer attributes:
 *   data-parallax            (required) marks the element as a parallax layer
 *   data-parallax-shift="N"  max vertical drift in %, can be negative for opposite direction
 *   data-parallax-scale="N"  optional zoom (use on the background so its drift never reveals an edge)
 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var containers = document.querySelectorAll('.pdp-premium .premium_media_static');
  if (!containers.length) {
    return;
  }

  var groups = [];
  for (var i = 0; i < containers.length; i++) {
    var layers = containers[i].querySelectorAll('[data-parallax]');
    if (layers.length) {
      groups.push({ container: containers[i], layers: layers });
      for (var k = 0; k < layers.length; k++) {
        layers[k].style.willChange = 'transform';
      }
    }
  }
  if (!groups.length) {
    return;
  }

  var ticking = false;

  function update() {
    ticking = false;
    var viewportH = window.innerHeight;
    var isMobile = window.innerWidth < 1000;

    for (var g = 0; g < groups.length; g++) {
      var box = groups[g].container.getBoundingClientRect();
      if (box.bottom < 0 || box.top > viewportH) {
        continue; // offscreen
      }

      // progress: +1 entering at the bottom, -1 after leaving the top, 0 centered.
      var center = box.top + box.height / 2;
      var progress = (center - viewportH / 2) / (viewportH / 2 + box.height / 2);
      if (progress > 1) progress = 1;
      else if (progress < -1) progress = -1;

      var layers = groups[g].layers;
      for (var l = 0; l < layers.length; l++) {
        var el = layers[l];
        // Mobile can override the shift (e.g. foreground book stays put, only bg drifts).
        var shiftAttr = isMobile && el.hasAttribute('data-parallax-shift-mobile')
          ? el.getAttribute('data-parallax-shift-mobile')
          : el.getAttribute('data-parallax-shift');
        var shift = parseFloat(shiftAttr) || 0;
        var scale = parseFloat(el.getAttribute('data-parallax-scale')) || 1;
        var ty = (progress * shift).toFixed(3);
        el.style.transform = 'translateY(' + ty + '%)' + (scale !== 1 ? ' scale(' + scale + ')' : '');
      }
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();

/*
 * Perfect addition — AJAX add-to-cart for the product card (adds without
 * redirecting to /cart). Mirrors the theme's product-form flow: POST /cart/add.js
 * with sections=mini-cart, then dispatch cart:updated + cart:refresh and open the
 * mini-cart drawer. The href stays as a no-JS fallback.
 */
(function () {
  document.addEventListener('click', function (event) {
    var atc = event.target.closest && event.target.closest('.pdp-premium .premium-perfect-card__atc');
    if (!atc) {
      return;
    }
    var variantId = atc.getAttribute('data-variant-id');
    if (!variantId) {
      return;
    }
    event.preventDefault();

    var routes = (window.themeVariables && window.themeVariables.routes) || {};
    var addUrl = (routes.cartAddUrl || '/cart/add') + '.js';
    var cartUrl = (routes.cartUrl || '/cart') + '.js';

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    body.append('sections', ['mini-cart']);

    atc.setAttribute('aria-busy', 'true');

    fetch(addUrl, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; });
      })
      .then(function (added) {
        atc.removeAttribute('aria-busy');
        if (!added.ok) {
          return;
        }
        return fetch(cartUrl)
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cart }
            }));
            cart.sections = added.json.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cart, openMiniCart: true }
            }));
          });
      })
      .catch(function () {
        atc.removeAttribute('aria-busy');
      });
  });
})();
